import { Link } from 'react-router-dom';
import MediaFigure from '../components/MediaFigure';
import foundationsPoured from '../Foundations-Poured-2026-06-16.jpg';
import may2026SurfaceWater from '../may-2026-surface-water-treatment-works.png';
import serviceTrenches from '../service-trenches-sewer-water-electric-internet.png';
import siteReadyFoundations from '../Site-Ready-Foundations-2026-06-16.jpg';
import { GM_CONTRACTORS_URL } from '../site';

function BuildProgressPage() {
  return (
    <main className="Page Page--subpage">
      <div className="Page-content">
        <h1 className="Page-title">Build progress</h1>
        <p className="Page-intro">
          Work is underway on our first two semi-detached homes. The photos
          below follow the site in chronological order — from early service
          connections through to the latest on-site developments.
        </p>

        <ol className="Progress-list">
          <li className="Progress-step">
            <h2 className="Progress-step-heading">Services to site</h2>
            <p className="Progress-step-text">
              Service trenches are in place for{' '}
              <strong>sewer, water, electric, and internet</strong>. Both plots
              are already <strong>fully connection-ready</strong> — a strong
              foundation before above-ground construction begins.
            </p>
            <p className="Progress-partner">
              We are pleased to be working with our fantastic groundworks
              sub-contractor{' '}
              <a
                href={GM_CONTRACTORS_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Glynn Martyn
              </a>{' '}
              of{' '}
              <a
                href={GM_CONTRACTORS_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                GM Contractors Devon
              </a>{' '}
              on site preparation and service connections.
            </p>
            <MediaFigure
              src={serviceTrenches}
              alt="Service trenches for sewer, water, electric and internet connections across the site"
              caption="Service trenches — sewer, water, electric, and internet"
            />
          </li>

          <li className="Progress-step Progress-step--highlight">
            <p className="Progress-update-label">Latest exciting update on the site</p>
            <h2 className="Progress-step-heading">Surface water treatment works — May 2026</h2>
            <p className="Progress-step-text">
              Surface water treatment works are now progressing on site — an
              important step in preparing the development for the build ahead.
            </p>
            <MediaFigure
              src={may2026SurfaceWater}
              alt="Surface water treatment works on the development site in May 2026"
              caption="May 2026 — surface water treatment works"
            />
          </li>

          <li className="Progress-step">
            <h2 className="Progress-step-heading">Foundations — June 2026</h2>
            <p className="Progress-step-text">
              Foundations for plots are poured and completed.
            </p>
            <div
              className="MediaGallery MediaGallery--pair MediaGallery--in-step"
              role="group"
              aria-label="Completed foundations for both plots"
            >
              <MediaFigure
                src={foundationsPoured}
                alt="Concrete foundations being poured on the development site, June 2026"
                caption="Foundations poured"
              />
              <MediaFigure
                src={siteReadyFoundations}
                alt="Both plots with completed foundation works ready for build, June 2026"
                caption="Site ready — foundations complete"
              />
            </div>
          </li>
        </ol>

        <div className="Page-actions">
          <Link to="/development-site" className="Button">
            View our first builds
          </Link>
          <Link to="/" className="Button Button--secondary">
            Back to home
          </Link>
        </div>
      </div>
    </main>
  );
}

export default BuildProgressPage;
